import axios from "@/axios"
// import * as types from '@/store/mutation-types'

export default {
    namespaced: true,

    actions: {
        delete({ commit }, { id }) {
            return axios.delete(`/Attendances/EmployeeWorkDay/${id}`)
        }
    }
}